import { useCallback, useContext, useMemo } from 'react';
import { FeatureFlagContext } from '@/components/feature-flag/feature-flag-provider';
import { CLIENT_SECRETS } from '@/config/client_secrets';

const currentBroker = CLIENT_SECRETS.BROKER;

/**
 * Hook to access feature flags from the context
 * @param {string} scope - The scope of the feature flags ('global' or 'brokers')
 * @returns {object} - {flagValues, isLoading, error, refreshFlags}
 */
export const useFeatureFlag = (scope = 'global') => {
  const { flags, isLoading, error, refreshFlags } =
    useContext(FeatureFlagContext);

  const extractFlagsForScope = useCallback(
    flags => {
      if (!flags || typeof flags !== 'object') {
        return null;
      }

      const scopedFlags = flags[scope];
      if (!scopedFlags) {
        return null;
      }

      // Handle broker-specific flags
      if (scope === 'brokers') {
        return currentBroker ? scopedFlags[currentBroker] : null;
      }

      return scopedFlags;
    },
    [scope]
  );

  const flagValues = useMemo(() => {
    return extractFlagsForScope(flags);
  }, [flags, extractFlagsForScope]);

  return { flagValues, isLoading, error, refreshFlags };
};
